import { render, staticRenderFns } from "./FaqAccordion.vue?vue&type=template&id=1a301954&scoped=true"
import script from "./FaqAccordion.vue?vue&type=script&lang=ts"
export * from "./FaqAccordion.vue?vue&type=script&lang=ts"
import style0 from "./FaqAccordion.vue?vue&type=style&index=0&id=1a301954&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a301954",
  null
  
)

export default component.exports